import React from "react";
import { tcgplayerUrl, soldListingsUrl } from "../shared/utils";

/**
 * Two places to look a card up, on every card.
 *
 * TCGplayer is where the market price comes from and where the listing is;
 * eBay's sold listings are the only free answer to what a played copy really
 * fetches, now that nothing below Near Mint is estimated. The Pokemon search
 * had both, One Piece had one, and the collection — the screen where you are
 * most likely holding the card — had neither.
 *
 * @param card   { name, number|displayNumber, externalUrl?, setName?, game? }
 * @param game   "pokemon" | "onepiece" — read off the card when it carries one
 */
export default function CardLinks({ card, game }) {
  if (!card?.name) return null;
  const which = card.game || game || "pokemon";
  // What is printed on the card, not the id we invented for it.
  const number = card.displayNumber || card.number || "";
  const setName = which === "onepiece" ? "" : card.setName || "";

  const tcg = card.externalUrl || tcgplayerUrl(which, card.name, number);
  const sold = soldListingsUrl(card.name, number, setName);

  return (
    <span className="card-links">
      {tcg && (
        <a className="card-link" href={tcg} target="_blank" rel="noreferrer">
          TCGplayer
        </a>
      )}
      {sold && (
        <a className="card-link" href={sold} target="_blank" rel="noreferrer">
          Sold on eBay
        </a>
      )}
    </span>
  );
}
